import { getSpotFromSearch } from './get-spot-from-search.ts';

export { getSpotFromSearch };
